<template>
  <div>
    <TopBanner
      title="元宇宙工厂"
      :bgImg="require('@/assets/product/MetaverseFactory/banner-bg.png')"
    >
      用端到端的数字化集成技术，去除一切中间环节，实现C2M+OTD的自适应运营。
    </TopBanner>
    <TopNav :list="nav" />
    <ViewMain title="元宇宙工厂" theme="gray" :id="getNavHash('数字孪生')">
      <ViewContent title="产品介绍">
        结合G-iPS数字孪生孪生软件和游戏引擎技术,
        可将工程中已经建模的产线模型和布局一键导入到元宇宙工厂环境中带来新的体验和交互。借助英伟达元宇宙平台Omniverse提供的强大算力可实现物理级逼真的画面和效果。元宇宙工厂将现实工业环境中的研发设计、生产制造、营销销售、售后服务等环节和场景在虚拟空间实现全面部署。
        <div style="text-align: center; margin-top: 40px">
          <img src="@/assets/product/MetaverseFactory/pic-1.png" alt="" />
        </div>
      </ViewContent>
      <ViewContent title="产品功能">
        虚实同步：虚拟制造，耦合同步、实时监控：运行监测，及时干预、逆向控制：实时干涉，协同设计、数据可视化：聚合数据，洞见未来、大屏数显：数字分析，智能制造、移动端操作：人机协同，远程运维、XR模式：
        混合现实，体验升级、多端用户: 多人在线。
      </ViewContent>
      <ViewContent title="产品价值">
        <OrderedList
          :list="[
            {
              content:
                '可将数字孪生软件内使用的CAD模型和产线布局快速导入元宇宙场景中,避免重复建模,缩短项目周期；',
            },
            {
              content:
                '元宇宙工厂中项目团队可以将从构思和概念设计到工厂车间的生产自动化流程的每个阶段连接到一起并且在AI的支持下高效智能运行；',
            },
            {
              content:
                '元宇宙工厂可以在移动端和XR端高效运行并提供远程体验,突破空间和时间的约束；',
            },
            {
              content:
                '通过混合现实设备,支持远程专家指导会议。缩短问题解决时间，节约差旅成本；',
            },
          ]"
        />
      </ViewContent>
    </ViewMain>
    <ViewMain title="" theme="gray" :id="getNavHash('未来工厂')" />
    <ViewMain
      title="业务协同平台"
      theme="gray"
      :id="getNavHash('业务协同平台')"
    >
      <ViewContent
        title="产品介绍"
        jumpText="免费试用>>"
        jumpUrl="https://coop.c2m-mom.com/"
      >
        C2M的协同设计制造平台。是一个面向汽车制造和汽车相关零部件制造，满足其设计制造全过程自动化、数字化、协同化需求的智能平台。它涵盖了从产品概念设计到最终交付客户的业务操作全流程。
        <div style="text-align: center; margin-top: 40px">
          <img src="@/assets/product/MetaverseFactory/c2m_coop1.png" alt="" />
        </div>
        <div style="text-align: center; margin-top: 40px">
          <img src="@/assets/product/MetaverseFactory/c2m_coop2.png" alt="" />
        </div>
        <div style="text-align: center; margin-top: 40px">
          <img src="@/assets/product/MetaverseFactory/c2m_coop.png" alt="" />
        </div>
      </ViewContent>
      <ViewContent title="产品功能">
        <p>
          在产品设计工程阶段，平台解决了设计组件与知识库共享、设计仿真数据同步等关键问题，他能提升了设计效率和质量。
        </p>
        <br />

        <p>
          在智能制造阶段，基于数字孪生技术，平台实现了对制造过程的可视化监控和质量检查，确保每一件产品都符合企业标准。而在供应链和运输阶段，平台通过物流驱动和线上跟踪，确保了产品按时、准确地送达客户手中。
        </p>
        <br />
        <p>
          平台实现了上下游企业的紧密协同。通过平台，供应商、制造商，现场实施等各个环节可以实时共享信息，协同工作，从而优化整个项目的开展效率。
        </p>
        <br />
      </ViewContent>
      <ViewContent title="产品优势">
        <OrderedList
          :list="[
            {
              content:
                '数据安全方面也是平台的技术核心护城河。自主研发了核心加密协议，采用裸金属架构的虚拟化技术，平台绑定的云桌面实现了VDI 和 IDV 技术融合。在研发和生产过程中，保密云桌面提供了安全的 工作环境，确保研发和生产数据不被外部人员非法访问或篡改。<br/><br/><br/>',
            },
            {
              content:
                '联合NVIDIA开发了适配于工业软件的协同场景。作为NVIDIA在工业制造领域的重要合作伙伴，自研了多款设计、仿真软件的连接器，便捷实现工业CAD中的数字资产流通。在工业CAD领域各个厂家的数据格式转换和协同一直是一个很难棘手的问题，通过和Omniverse平台的结合，让每一个使用协同平台的客户团队，拥有属于自己的三维共享空间，实现了将现实场景转化为“可看、可用、可共享”的数字场景。',
            },
          ]"
        />
      </ViewContent>
    </ViewMain>
    <ViewMain
      title="数字资产超市"
      theme="gray"
      :id="getNavHash('数字资产超市')"
    >
      <ViewContent title="产品介绍">
        <p>赋能汽车焊装行业智能制造的全新引擎</p>
        <br />
        <p>
          在智能制造与工业4.0的浪潮下，汽车焊装行业的数字化转型正以前所未有的速度推进。工艺验证作为生产线开发的核心环节，其效率与精度直接决定了产品上市周期与制造成本。然而，传统的验证方式往往受限于资源分散、标准不统一、重复建模等问题，导致开发周期长、协作效率低。为此，我们创新性地打造了“数字资产超市”——一个高度标准化、模块化的数字资产库，旨在为汽车焊装行业提供一站式工艺验证解决方案，彻底革新自动化线体仿真验证的流程。
        </p>
        <br />
        标准化资产库：快速搭建，精准验证
        <br />
        <p>
          数字资产超市的核心价值在于其全场景覆盖的标准化数字资产。我们深度整合了焊装行业工艺验证所需的各类高精度模型与功能单元，涵盖机器人、焊枪（伺服焊枪、气动焊枪等）、修模器、安全围栏、PLC控制柜、输送线体等数百种关键组件。例如，当工程师需要验证点焊工艺时，无需从零开始建模，只需通过资产库快速调用预置的机器人运动模型、焊枪参数化工具、工艺逻辑接口等单元，即可快速生成完整的虚拟工作站场景。
        </p>
        <div style="text-align: center; margin-top: 40px">
          <img
            src="@/assets/product/MetaverseFactory/c2m_dig_market.png"
            alt=""
          />
        </div>
      </ViewContent>
      <ViewContent title="应用场景">
        <p>数字资产超市的应用贯穿焊装全生命周期：</p>
        <br />
        <p>
          虚拟调试：在产线投产前，通过资产库快速构建虚拟环境，验证机器人轨迹、节拍与PLC逻辑，减少现场调试风险。
        </p>
        <br />
        <p>
          工艺创新：支持新工艺（如激光焊接、胶接）的预研验证，通过参数化工具模拟不同材料与工艺组合的效果。
        </p>
          <br />
        <p>
          员工培训：基于标准化场景生成交互式操作手册，缩短新员工对复杂设备的熟悉时间。
        </p>
        <br />
      </ViewContent>
      <ViewContent title="核心优势">
        <OrderedList
          :list="[
            {
              content:
                '极速部署,缩短开发周期<br/>传统仿真验证中，70%的时间消耗在基础场景搭建与数据准备上。数字资产超市通过“即插即用”的模块化设计，将验证准备时间缩短80%，使工程师能够聚焦于工艺逻辑优化与风险规避，加速项目交付;<br/>',
            },
            {
              content:
                '智能协同,打破数据孤岛<br/>资产库支持多学科协作，机械、电气、工艺团队可在同一平台调用统一标准的模型，避免因格式转换或版本差异导致的沟通成本。同时，资产库与主流仿真软件（如Process Simulate）无缝兼容，实现数据流全链路打通。',
            },
            {
              content:
                '工艺知识沉淀 <br/>赋能企业数字孪生所有入库资产均附带工艺参数（如焊接电流、压力曲线）与历史验证数据，形成企业专属的“工艺知识图谱”。随着使用频次增加，资产库将进化成动态更新的数字孪生底座，为未来产线优化提供数据支撑。',
            },
            {
              content:
                `成本优化,资源高效复用 <br/>通过集中管理高价值数字资产，企业可避免重复采购或定制开发，降低30%以上的仿真软硬件投入。此外，库内资产支持灵活配置（如机器人品牌切换、布局调整），满足多车型共线生产的快速适配需求。`,
            },
          ]"
        />
      </ViewContent>
    </ViewMain>
  </div>
</template>

<script>
import ViewMain from '@/components/ViewMain'
import ViewContent from '@/components/ViewContent'
import TopBanner from '@/components/TopBanner'
import TopNav from '@/components/TopNav'
import OrderedList from '@/components/OrderedList'
import mixin from '@/views/product/mixin'
import nav from './nav'

export default {
  components: {
    ViewMain,
    ViewContent,
    TopBanner,
    TopNav,
    OrderedList,
  },
  mixins: [mixin],
  data () {
    return {
      nav,
    }
  },
}
</script>

<style lang="less" scoped></style>
